module.exports = __webpack_public_path__ + "img/taib2.eee8d714.png";